import React from 'react';
import Timeline from 'react-timeline';


const TimeLine = () => {
  const timelineData = [
    {
      title: '4 Days Before Your Colonoscopy',
      content: 'Stop eating corn, tomatoes, nuts, popcorn, raw fruits or vegetables, seeds, grains, or nuts. Avoid iron tablets, fiber supplements, fish oil or vitamin D.',
    },
    {
      title: 'What to Eat the Day Before Your Colonoscopy',
      content: 'Stop eating all solid foods and dairy, and start hydrating by drinking clear liquids the entire day.',
    },
    // Add more steps as needed
  ];

  return (
    <div>
      <img src="your_image_path.jpg" alt="Sutab Prep Instructions" />
      <Timeline>
        {timelineData.map((step, index) => (
          <Timeline.Item key={index}>
            <Timeline.Title>{step.title}</Timeline.Title>
            <Timeline.Content>{step.content}</Timeline.Content>
          </Timeline.Item>
        ))}
      </Timeline>
    </div>
  );
}

export default TimeLine;